import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

type GreetingProps = { className?: string };

export const Greeting = ({ className }: GreetingProps) => {
    const { t } = useTranslation();

    return (
        <p className={className}>
            {DateTime.now().hour < 12
                ? t("good_morning")
                : DateTime.now().hour < 18
                  ? t("good_afternoon")
                  : t("good_evening")}
        </p>
    );
};
